var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDlpFooterTikTokIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 21,
    fill: "white",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.75 19.6328C27.168 19.668 25.6914 19.1758 24.4258 18.2617V24.5547C24.4258 26.9453 22.9492 29.0547 20.6992 29.8984C18.4844 30.7422 15.9531 30.1094 14.4062 28.3164C12.8242 26.4883 12.543 23.9219 13.668 21.8125C14.793 19.7383 17.1133 18.5781 19.5039 18.8945V22.0586C18.4141 21.707 17.2188 22.0938 16.5508 23.0078C15.918 23.957 15.918 25.1875 16.5859 26.1016C17.2539 27.0156 18.4492 27.4023 19.5039 27.0508C20.5938 26.6992 21.332 25.6797 21.332 24.5547V12.25H24.4258C24.4258 12.5312 24.4258 12.7773 24.4961 13.0586C24.707 14.2188 25.375 15.2383 26.3945 15.8711C27.0625 16.3281 27.9062 16.5742 28.75 16.5742V19.6328Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDlpFooterTikTokIcon);
export default __webpack_public_path__ + "static/media/DlpFooterTikTokIcon.db6b00b9b3634aee0737a97be9401ccc.svg";
export { ForwardRef as ReactComponent };